import * as Yup from "yup";

export const validatorStringGeneric = Yup.string()
  .trim()
  .max(100, "Can't be more than 100 symbols");
